import { useMemo } from 'react';
import { useLeague } from './useLeague';

type LeagueMaxTokensReturn = {
  maxTokens: number;
};

export const useLeagueMaxTokens = (): LeagueMaxTokensReturn => {
  const { currentSeason } = useLeague();

  const maxTokens = useMemo(() => {
    if (!currentSeason) return 0;

    const baseTokens = Number(currentSeason.baseTokens ?? 0);
    const referralTokens = Number(currentSeason.referralTokens ?? 0);

    const has2x1 = currentSeason.bonus?.includes('2x1') ?? false;

    const purchasableTokens = has2x1 ? baseTokens * 2 : baseTokens;

    return purchasableTokens + referralTokens;
  }, [currentSeason]);

  return {
    maxTokens,
  };
};
